import { SOUNDBOARD_CDN } from 'src/config-global';
import {
  VoiceChannelMember,
  useVoiceChannelContext,
} from 'src/provider/VoiceChannel';
import { useLivekitRTCState } from 'src/provider/VoiceChannel/livekit/useLivekitRTCState';
import { PlaySoundBoardType } from 'src/socket/listeners/voice-channel';

export const usePlaySound = () => {
  const { setVoiceChannels } = useVoiceChannelContext();
  const { activeVoiceChannel, localParticipant, connectionStatus } =
    useLivekitRTCState();

  const updateMemberFromActiveVoiceChannel = (
    memberId: string,
    params: Partial<VoiceChannelMember>,
  ) => {
    setVoiceChannels((prevVoiceChannels) =>
      prevVoiceChannels.map((stateVoiceChannel) =>
        stateVoiceChannel.channel._id === activeVoiceChannel?.channel?._id
          ? {
              ...stateVoiceChannel,
              members: stateVoiceChannel.members.map((stateMember) =>
                memberId === stateMember.user._id
                  ? {
                      ...stateMember,
                      ...params,
                    }
                  : stateMember,
              ),
            }
          : stateVoiceChannel,
      ),
    );
  };

  const handleSetUserPlayedSoundBoard = (
    userId: string,
    playedSound: string,
  ) => {
    updateMemberFromActiveVoiceChannel(userId, { playedSound });
  };

  const playSound = (data: PlaySoundBoardType) => {
    if (
      data.channelId !== activeVoiceChannel?.channel?._id ||
      connectionStatus !== 'connected'
    )
      return;
    const soundUrl = `${SOUNDBOARD_CDN}${data.soundId}`;
    let audio = new Audio(soundUrl);
    handleSetUserPlayedSoundBoard(data.requested, data.icon || ':loudspeaker:');
    audio.addEventListener('ended', () => {
      handleSetUserPlayedSoundBoard(data.requested, '');
      audio.removeEventListener('ended', () =>
        handleSetUserPlayedSoundBoard(data.requested, ''),
      );
    });
    audio.volume = localParticipant.deaf ? 0 : data.volume || 1;
    audio.play().then();
  };

  return { playSound };
};
